// ==================== LISTES ====================
export const PAYS_LIST = [
  'Afghanistan', 'Afrique du Sud', 'Albanie', 'Algérie', 'Allemagne', 'Andorre', 'Angola', 'Antigua-et-Barbuda',
  'Arabie Saoudite', 'Argentine', 'Arménie', 'Australie', 'Autriche', 'Azerbaïdjan', 'Bahamas', 'Bahreïn',
  'Bangladesh', 'Barbade', 'Belgique', 'Belize', 'Bénin', 'Bhoutan', 'Biélorussie', 'Birmanie', 'Bolivie',
  'Bosnie-Herzégovine', 'Botswana', 'Brésil', 'Brunei', 'Bulgarie', 'Burkina Faso', 'Burundi', 'Cambodge',
  'Cameroun', 'Canada', 'Cap-Vert', 'Chili', 'Chine', 'Chypre', 'Colombie', 'Comores', 'Congo', 'Corée du Sud',
  'Costa Rica', 'Côte d\'Ivoire', 'Croatie', 'Cuba', 'Danemark', 'Djibouti', 'Dominique', 'Égypte', 'El Salvador',
  'Émirats arabes unis', 'Équateur', 'Érythrée', 'Espagne', 'Estonie', 'Eswatini', 'États-Unis', 'Éthiopie',
  'Fidji', 'Finlande', 'France', 'Gabon', 'Gambie', 'Géorgie', 'Ghana', 'Grèce', 'Grenade', 'Guatemala',
  'Guinée', 'Guinée équatoriale', 'Guinée-Bissau', 'Guyana', 'Haïti', 'Honduras', 'Hongrie', 'Îles Cook',
  'Îles Marshall', 'Îles Salomon', 'Inde', 'Indonésie', 'Irak', 'Iran', 'Irlande', 'Islande', 'Israël', 'Italie',
  'Jamaïque', 'Japon', 'Jordanie', 'Kazakhstan', 'Kenya', 'Kirghizistan', 'Kiribati', 'Koweït', 'Laos', 'Lesotho',
  'Lettonie', 'Liban', 'Libéria', 'Libye', 'Liechtenstein', 'Lituanie', 'Luxembourg', 'Macédoine', 'Madagascar',
  'Malaisie', 'Malawi', 'Maldives', 'Mali', 'Malte', 'Maroc', 'Maurice', 'Mauritanie', 'Mexique', 'Micronésie',
  'Moldavie', 'Monaco', 'Mongolie', 'Monténégro', 'Mozambique', 'Namibie', 'Nauru', 'Népal', 'Nicaragua',
  'Niger', 'Nigéria', 'Norvège', 'Nouvelle-Zélande', 'Oman', 'Ouganda', 'Ouzbékistan', 'Pakistan', 'Palaos',
  'Palestine', 'Panama', 'Papouasie-Nouvelle-Guinée', 'Paraguay', 'Pays-Bas', 'Pérou', 'Philippines', 'Pologne',
  'Portugal', 'Qatar', 'République démocratique du Congo', 'Roumanie', 'Royaume-Uni', 'Russie', 'Rwanda', 'Saint-Kitts-et-Nevis', 'Saint-Marin',
  'Saint-Vincent-et-les-Grenadines', 'Sainte-Lucie', 'Samoa', 'Sao Tomé-et-Principe', 'Sénégal', 'Serbie',
  'Seychelles', 'Sierra Leone', 'Singapour', 'Slovaquie', 'Slovénie', 'Somalie', 'Soudan', 'Soudan du Sud',
  'Sri Lanka', 'Suède', 'Suisse', 'Suriname', 'Syrie', 'Tadjikistan', 'Tanzanie', 'Tchad', 'Thaïlande',
  'Timor oriental', 'Togo', 'Tonga', 'Trinité-et-Tobago', 'Tunisie', 'Turkménistan', 'Turquie', 'Tuvalu',
  'Ukraine', 'Uruguay', 'Vanuatu', 'Vatican', 'Venezuela', 'Viêt Nam', 'Yémen', 'Zambie', 'Zimbabwe'
];

export const LIEUX_FORMATION = [
  'Sup2i Aïn Sebaâ',
  'Alternance (Hertz)',
  'Marrakech(Ecole Sup2i)',
  'SMIT',
  'Isoset',
  'kénitra(Ecole sup2i)',
  'Sup2i Maarif',
  'Jobinteck',
  'Ode',
  'Mega',
  'IPM',
  'VAE',
  'Jobinteck 2026'
];

export const SOURCES_INSCRIPTION = [
  'Call',
  'Email',
  'Existing Customer',
  'Partner',
  'Parrainage',
  "Apporteur d'affaires",
  'Public Relations',
  'Visite campus',
  'Salon Maroc',
  'Salon Afrique',
  'Web Site',
  'Facebook',
  'Campaign',
  'Réseaux sociaux',
  'BDD Manuel',
  'Other',
  'Multisource'
];

// ==================== STRUCTURE FORMATION ====================
export const STRUCTURE_FORMATION = {
  MASI: {
    nom: 'MASI',
    niveauxManuels: true,
    specialites: [
      'Entreprenariat, audit et finance',
      'Développement commercial et marketing digital',
      'Logistique et Supply Chain Management'
    ],
    niveaux: {
      1: { specialites: [] },
      2: { specialites: [] },
      3: {
        specialites: [
          'Entreprenariat, audit et finance',
          'Développement commercial et marketing digital',
          'Logistique et Supply Chain Management'
        ]
      },
      4: {
        specialites: [
          'Management des Affaires et Systèmes d\'Information'
        ]
      },
      5: {
        specialites: [
          'Achats, Logistique et Supply Chain Management',
          'Développement Commercial et Marketing Digital',
          'Entrepreneuriat, Audit et Finance'
        ],
        options: {
          'Achats, Logistique et Supply Chain Management': [
            'Achats, Logistique et Supply Chain Management'
          ],
          'Développement Commercial et Marketing Digital': [
            'Développement Commercial et Marketing Digital'
          ],
          'Entrepreneuriat, Audit et Finance': [
            'Entrepreneuriat, Audit et Finance'
          ]
        }
      }
    }
  },
  IRM: {
    nom: 'IRM',
    niveauxManuels: true,
    specialites: [
      'Développement informatique',
      'Intelligence Artificielle',
      'Réseaux et cybersécurité'
    ],
    niveaux: {
      1: { specialites: [] },
      2: { specialites: [] },
      3: {
        specialites: [
          'Développement informatique',
          'Intelligence Artificielle',
          'Réseaux et cybersécurité'
        ]
      },
      4: {
        specialites: [
          'Génie informatique et innovation technologique',
          'Réseaux et Cybersécurité'
        ]
      },
      5: {
        specialites: [
          'Génie informatique et innovation technologique',
          'Réseaux et Cybersécurité'
        ],
        options: {
          'Génie informatique et innovation technologique': [
            'Big Data',
            'Génie Logiciel',
            'Intelligence Artificielle'
          ],
          'Réseaux et Cybersécurité': [
            'Cybersécurité',
            'Réseaux Nouvelle Génération'
          ]
        }
      }
    }
  },
  GENIE_CIVIL: {
    nom: 'GENIE_CIVIL',
    niveauxManuels: false,
    niveauFixe: 3,
    specialites: [
      'BIM & Modélisation numérique',
      'Gestion & Conduite de travaux'
    ],
    niveaux: {
      3: {
        specialites: [
          'BIM & Modélisation numérique',
          'Gestion & Conduite de travaux'
        ]
      }
    }
  },
  MECATRONIQUE: {
    nom: 'MECATRONIQUE',
    niveauxManuels: false,
    niveauFixe: 3,
    specialites: [
      'Automatisation des Systèmes industriels',
      'Génie Industriel',
      'Génie Mécanique'
    ],
    niveaux: {
      3: {
        specialites: [
          'Automatisation des Systèmes industriels',
          'Génie Industriel',
          'Génie Mécanique'
        ]
      }
    }
  },
  MASTER: {
    nom: 'Master',
    niveauxManuels: true,
    specialites: [
      'Qualité, Hygiène, Sécurité et Environnement (QHSE)',
      'Intelligence Économique et Management Stratégique'
    ],
    niveaux: {
      4: {
        specialites: [
          'Qualité, Hygiène, Sécurité et Environnement (QHSE)',
          'Intelligence Économique et Management Stratégique'
        ]
      },
      5: {
        specialites: [
          'Qualité, Hygiène, Sécurité et Environnement (QHSE)',
          'Intelligence Économique et Management Stratégique'
        ],
        options: {}
      }
    }
  },
  CYCLE_INGENIEUR: {
    nom: "CYCLE_INGENIEUR",
    niveauxManuels: true,
    cycles: {
      'Classes Préparatoires Intégrées': {
        niveaux: [1, 2],
        specialites: [],
        options: {}
      },
      'Cycle Ingénieur': {
        niveaux: [3, 4, 5],
        specialites: [
          'Génie Informatique',
          'Génie Mécatronique',
          'Génie Civil'
        ],
        options: {
          'Génie Informatique': [
            'Sécurité & Mobilité Informatique',
            'IA & Science des Données',
            'Réseaux & Cloud Computing'
          ],
          'Génie Mécatronique': [
            'Génie Mécanique',
            'Génie Industriel',
            'Génie Électrique : Automatisation des Systèmes Industriels'
          ],
          'Génie Civil': [
            "Structures & Ouvrages d'art",
            'Bâtiment & Efficacité Énergétique',
            'Géotechnique & Infrastructures'
          ]
        }
      }
    }
  },
  LICENCE_PRO: {
    nom: 'Licence Professionnelle',
    typeFormation: 'LICENCE_PRO',
    niveauxManuels: false,
    niveauFixe: 3,
    specialites: [
      'Logistique Industrielle',
      'Logistique, Transport & Distribution',
      'Transport International, Transit & Douanes',
      'Achats, Sourcing & Approvisionnement',
      'Qualité, Hygiène, Sécurité, Environnement',
      'Développement Informatique',
      'Intelligence Artificielle',
      'Réseaux & Cybersécurité',
      'Développement Commercial & Marketing Digital',
      'Entrepreneuriat, Audit & Finance',
      'Automatisation des Systèmes Industriels',
      'Génie Industriel',
      'Génie Mécanique',
      'BIM & Modélisation Numérique',
      'Gestion & Conduite de Travaux'
    ],
    options: {}
  },
  MASTER_PRO: {
    nom: 'Master Professionnel',
    typeFormation: 'MASTER_PRO',
    niveauxManuels: false,
    niveauFixe: 5,
    specialites: [
      'International Business : Global Trade & Logistics Law',
      'Supply Chain Management AI Powered',
      'Achats Stratégiques & Global Sourcing',
      'Achats Logistique et Supply Management',
      'QHSSE AI Powered',
      'Génie Informatique & Innovation Technologique : Big Data',
      'Génie Informatique & Innovation Technologique : Génie Logiciel',
      'Génie Informatique & Innovation Technologique : Intelligence Artificielle',
      'Réseaux & Cybersécurité : Cybersécurité',
      'Réseaux & Cybersécurité : Réseaux Nouvelle Génération',
      'Développement Commercial & Marketing Digital',
      'Entrepreneuriat, Audit & Finance',
      'Intelligence Économique & Management Stratégique',
      'Génie Mécatronique'
    ],
    options: {}
  }
};

export const FILIERE_BY_MODE = {
  FI: ['MASI', 'IRM', 'CYCLE_INGENIEUR', 'GENIE_CIVIL', 'MECATRONIQUE', 'MASTER'],
  TA: ['MASI', 'IRM', 'CYCLE_INGENIEUR', 'GENIE_CIVIL', 'MECATRONIQUE', 'MASTER'],
  Executive: ['LICENCE_PRO', 'MASTER_PRO'],
  VAE: ['LICENCE_PRO', 'MASTER_PRO']
};

// ==================== NORMALIZATION & MATCHING ====================
export const normalize = (s = "") =>
  s
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "et")
    .replace(/[^a-z0-9\s]/gi, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const buildCoursCandidates = (f) => {
  const raw = [];
  const n = Number(f.niveau || 0);
  const y = f.niveau ? `${f.niveau} Année` : "";

  if (!f.filiere) return [];

  if (f.filiere === "MASI") {
    if (n >= 1 && n <= 2) raw.push(`MASI ${y}`);
    if ((n === 3 || n === 4) && f.specialite) raw.push(`MASI ${f.specialite} ${y}`);
    if (n === 5) {
      if (f.specialite && f.option) raw.push(`MASI ${f.specialite} ${f.option} ${y}`);
      if (f.option) raw.push(`MASI ${f.option} ${y}`);
      if (f.specialite) raw.push(`MASI ${f.specialite} ${y}`);
    }
  } else if (f.filiere === "IRM") {
    if (n >= 1 && n <= 2) raw.push(`IRM ${y}`);
    if ((n === 3 || n === 4) && f.specialite) raw.push(`IRM ${f.specialite} ${y}`);
    if (n === 5) {
      if (f.specialite && f.option) raw.push(`IRM ${f.specialite} ${f.option} ${y}`);
      if (f.option) raw.push(`IRM ${f.option} ${y}`);
      if (f.specialite) raw.push(`IRM ${f.specialite} ${y}`);
    }
  } else if (f.filiere === "GENIE_CIVIL") {
    if (f.specialite) raw.push(`GENIE_CIVIL ${f.specialite} 3 Année`);
    if (f.specialite) raw.push(`Licence Génie Civil ${f.specialite} 3 Année`);
    if (f.specialite) raw.push(`Génie Civil ${f.specialite} 3 Année`);
    raw.push(`Génie Civil 3 Année`);
    raw.push(`Licence Génie Civil 3 Année`);
  } else if (f.filiere === "MECATRONIQUE") {
    if (f.specialite) raw.push(`MECATRONIQUE ${f.specialite} 3 Année`);
    if (f.specialite) raw.push(`Licence Génie Mécatronique ${f.specialite} 3 Année`);
    if (f.specialite) raw.push(`Génie Mécatronique ${f.specialite} 3 Année`);
    raw.push(`Génie Mécatronique 3 Année`);
    raw.push(`Licence Génie Mécatronique 3 Année`);
  } else if (f.filiere === "CYCLE_INGENIEUR") {
    if (n >= 1 && n <= 2) raw.push(`Classes Préparatoires ${y}`);
    if (n >= 3) {
      if (n === 5 && f.optionIngenieur) raw.push(`${f.optionIngenieur} 5 Année`);
      if (f.specialiteIngenieur) raw.push(`${f.specialiteIngenieur} ${y}`);
    }
  } else if (f.filiere === "LICENCE_PRO") {
    if (f.specialiteLicencePro) {
      let s = `Licence Pro ${f.specialiteLicencePro}`;
      if (f.optionLicencePro) s += ` - ${f.optionLicencePro}`;
      raw.push(s);
    }
  } else if (f.filiere === "MASTER_PRO") {
    if (f.specialiteMasterPro) {
      let s = `Master Pro ${f.specialiteMasterPro}`;
      if (f.optionMasterPro) s += ` - ${f.optionMasterPro}`;
      raw.push(s);
    }
  } else if (f.filiere === "MASTER") {
    if (n === 4 && f.specialite) {
      raw.push(`Master ${f.specialite} ${y}`);
      const m = f.specialite.match(/\(([^)]+)\)/);
      if (m) raw.push(`Master ${m[1]} ${y}`);
    }
    if (n === 5) {
      if (f.specialite && f.option) raw.push(`Master ${f.specialite} ${f.option} ${y}`);
      if (f.specialite) {
        raw.push(`Master ${f.specialite} ${y}`);
        const m = f.specialite.match(/\(([^)]+)\)/);
        if (m) raw.push(`Master ${m[1]} ${y}`);
      }
    }
  }

  const isTA = f.niveauFormation === 'TA';
  const isFI = f.niveauFormation === 'FI';

  const out = [];
  raw.filter(Boolean).forEach(c => {
    if (isTA) {
      out.push(`${c} TA`);
      out.push(c);
    } else if (isFI) {
      out.push(`${c} FI`);
      out.push(c);
    } else {
      out.push(c);
      out.push(`${c} FI`);
      out.push(`${c} TA`);
    }
  });

  return Array.from(new Set(out));
};

export const pickBestCours = (listeCours, candidates, niveauFormation) => {
  if (!Array.isArray(listeCours) || listeCours.length === 0) return null;
  const noms = listeCours.map(c => c.nom || c);
  const normNoms = noms.map(normalize);

  // 1) Match exact normalisé
  for (const cand of candidates) {
    const nc = normalize(cand);
    const idx = normNoms.findIndex(n => n === nc);
    if (idx !== -1) return noms[idx];
  }

  // Helper pour vérifier l'incompatibilité de cycle (Master vs Licence)
  const isDegreeIncompatible = (cNorm, targetNorm) => {
    const cMaster = cNorm.includes('master');
    const cLicence = cNorm.includes('licence');
    const tMaster = targetNorm.includes('master');
    const tLicence = targetNorm.includes('licence');

    if (cMaster && tLicence && !tMaster) return true;
    if (cLicence && tMaster && !tLicence) return true;
    return false;
  };

  // 2) "contains" (cand ⊆ cours)
  for (const cand of candidates) {
    const nc = normalize(cand);
    let bestIdx = -1, bestScore = 0;
    normNoms.forEach((n, i) => {
      if (isDegreeIncompatible(nc, n)) return;
      const score = n.includes(nc) ? nc.length / n.length : 0;
      if (score > bestScore) { bestScore = score; bestIdx = i; }
    });
    if (bestIdx !== -1) return noms[bestIdx];
  }

  // 3) Recouvrement de tokens (secours)
  if (candidates.length) {
    const askedYear = candidates[0].match(/(\d)\s+Année/i);
    const candNorm = normalize(candidates[0]);
    // Ignorer les mots génériques comme 'pro', 'des', 'les', 'et'
    const stopWords = new Set(['pro', 'des', 'les', 'pour', 'avec', 'sans', 'dans', 'sur', 'une', 'par', 'casablanca']);
    const tokens = Array.from(new Set(candNorm.split(" ").filter(t => t.length > 2 && !stopWords.has(t))));
    let bestIdx = -1, hitsMax = 0;
    normNoms.forEach((n, i) => {
      if (isDegreeIncompatible(candNorm, n)) return;

      const yearMatch = n.match(/(\d)\s+annee/i);
      if (askedYear && yearMatch && askedYear[1] !== yearMatch[1]) {
        return;
      }
      let hits = tokens.reduce((acc, t) => acc + (n.includes(t) ? 1 : 0), 0);
      if (yearMatch && askedYear && yearMatch[1] === askedYear[1]) hits += 2;
      if (hits >= 2 && hits > hitsMax) { hitsMax = hits; bestIdx = i; }
    });
    if (bestIdx !== -1 && hitsMax >= 2) return noms[bestIdx];
  }
  return null;
};

export const autoAssignCours = (form, setForm, listeCours, isLockedByUser) => {
  const cands = buildCoursCandidates(form);
  if (!cands.length || isLockedByUser) return;
  const best = pickBestCours(listeCours, cands, form.niveauFormation);
  if (!best) return;
  setForm(prev => {
    const current = prev.cours || [];
    if (current.includes(best)) return prev;
    return { ...prev, cours: [best] };
  });
};

// ==================== GETTERS ====================
export const getFilieresParMode = (mode) => FILIERE_BY_MODE[mode] || [];

export const getNiveauxDisponibles = (filiere) => {
  if (!filiere) return [];
  const formationData = STRUCTURE_FORMATION[filiere];
  if (!formationData) return [];
  // If formation has a fixed level (LICENCE_PRO), no manual level selection
  if (!formationData.niveauxManuels) return [];
  // Use niveaux from the formation structure if defined
  if (formationData.niveaux) {
    return Object.keys(formationData.niveaux).map(Number).sort((a, b) => a - b);
  }
  // Default: 1-5
  return [1, 2, 3, 4, 5];
};

export const getSpecialitesDisponibles = (filiere, niveau) => {
  const formationData = STRUCTURE_FORMATION[filiere];
  if (!formationData) return [];

  if (filiere === 'LICENCE_PRO' || filiere === 'MASTER_PRO') {
    return formationData.specialites || [];
  }

  const niveauInt = parseInt(niveau);
  if (niveauInt < 3) return [];

  if (filiere === 'MASI') {
    if (niveauInt === 3) {
      return [
        'Entreprenariat, audit et finance',
        'Développement commercial et marketing digital',
        'Logistique et Supply Chain Management'
      ];
    } else if (niveauInt === 4) {
      return [
        'Management des Affaires et Systèmes d\'Information'
      ];
    } else if (niveauInt === 5) {
      return [
        'Achats, Logistique et Supply Chain Management',
        'Développement Commercial et Marketing Digital',
        'Entrepreneuriat, Audit et Finance'
      ];
    }
  }

  if (filiere === 'IRM') {
    if (niveauInt === 3) {
      return ['Développement informatique', 'Intelligence Artificielle', 'Réseaux et cybersécurité'];
    } else if (niveauInt >= 4) {
      return ['Génie informatique et innovation technologique', 'Réseaux et Cybersécurité'];
    }
  }

  if (filiere === 'GENIE_CIVIL') {
    return ['BIM & Modélisation numérique', 'Gestion & Conduite de travaux'];
  }

  if (filiere === 'MECATRONIQUE') {
    return ['Automatisation des Systèmes industriels', 'Génie Industriel', 'Génie Mécanique'];
  }

  return formationData.specialites || [];
};

export const getOptionsDisponibles = (filiere, niveau, specialite) => {
  if (!filiere || !STRUCTURE_FORMATION[filiere]) return [];

  const formationData = STRUCTURE_FORMATION[filiere];

  if (filiere === 'LICENCE_PRO' || filiere === 'MASTER_PRO') {
    if (!specialite) return [];
    return formationData.options[specialite] || [];
  }

  if (!specialite || String(niveau) !== '5') return [];

  const niveauData = formationData.niveaux[5];
  return niveauData && niveauData.options && niveauData.options[specialite]
    ? niveauData.options[specialite]
    : [];
};

export const getSpecialites2Disponibles = (filiere2) => {
  if (!filiere2 || !STRUCTURE_FORMATION[filiere2]) return [];
  const data = STRUCTURE_FORMATION[filiere2];

  if (filiere2 === 'CYCLE_INGENIEUR') {
    return data.cycles?.['Cycle Ingénieur']?.specialites || [];
  }

  if (filiere2 === 'IRM') {
    return [
      'Développement informatique',
      'Intelligence Artificielle',
      'Réseaux et cybersécurité',
      'Génie informatique et innovation technologique',
      'Réseaux et Cybersécurité'
    ];
  }

  if (filiere2 === 'MASI') {
    return [
      'Entreprenariat, audit et finance',
      'Développement commercial et marketing digital',
      'Logistique et Supply Chain Management',
      'Management des Affaires et Systèmes d\'Information',
      'Achats, Logistique et Supply Chain Management'
    ];
  }

  return data.specialites || [];
};

export const getOptions2Disponibles = (filiere2, specialite2) => {
  if (!filiere2 || !STRUCTURE_FORMATION[filiere2]) return [];
  const data = STRUCTURE_FORMATION[filiere2];

  if (filiere2 === 'CYCLE_INGENIEUR') {
    if (specialite2 && data.cycles?.['Cycle Ingénieur']?.options?.[specialite2]) {
      return data.cycles['Cycle Ingénieur'].options[specialite2];
    }
    const allIngOpts = [];
    const optsObj = data.cycles?.['Cycle Ingénieur']?.options || {};
    Object.values(optsObj).forEach(arr => {
      arr.forEach(opt => { if (!allIngOpts.includes(opt)) allIngOpts.push(opt); });
    });
    return allIngOpts;
  }

  if (filiere2 === 'IRM') {
    if (specialite2) {
      const specNorm = normalize(specialite2);
      const optsObj = data.niveaux?.[5]?.options || {};
      for (const [key, opts] of Object.entries(optsObj)) {
        if (normalize(key).includes(specNorm) || specNorm.includes(normalize(key))) {
          return opts;
        }
      }
      if (specNorm.includes('dev') || specNorm.includes('informatique') || specNorm.includes('ia') || specNorm.includes('intelligence')) {
        return optsObj['Génie informatique et innovation technologique'] || [];
      }
      if (specNorm.includes('reseau') || specNorm.includes('cyber')) {
        return optsObj['Réseaux et Cybersécurité'] || [];
      }
    }
    return [
      'Big Data',
      'Génie Logiciel',
      'Intelligence Artificielle',
      'Cybersécurité',
      'Réseaux Nouvelle Génération'
    ];
  }

  if (filiere2 === 'MASI') {
    return [
      'Achats, Logistique et Supply Chain Management',
      'Développement Commercial et Marketing Digital',
      'Entrepreneuriat, Audit et Finance'
    ];
  }

  if (filiere2 === 'LICENCE_PRO') {
    if (specialite2 && data.options?.[specialite2]?.length > 0) {
      return data.options[specialite2];
    }
    return [
      'Développement Mobile',
      'Intelligence Artificielle et Data Analytics',
      'Développement JAVA JEE',
      'Développement Gaming et VR',
      'Administration des Systèmes et Cloud Computing'
    ];
  }

  if (filiere2 === 'MASTER_PRO') {
    if (specialite2 && data.options?.[specialite2]?.length > 0) {
      return data.options[specialite2];
    }
    return [
      'Systèmes de communication et Data center',
      'Management des Systèmes d\'Information',
      'Génie Logiciel',
      'Intelligence Artificielle et Data Science'
    ];
  }

  if (data.options && specialite2 && data.options[specialite2]) {
    return data.options[specialite2];
  }

  return [];
};


export const getCycleParNiveau = (niveau) => {
  const niveauInt = parseInt(niveau);
  if (niveauInt <= 2) return 'Classes Préparatoires Intégrées';
  if (niveauInt >= 3) return 'Cycle Ingénieur';
  return '';
};

export const getTypeFormation = (niveau) => {
  const niveauInt = parseInt(niveau);
  if (niveauInt <= 2) return 'Tronc commun';
  if (niveauInt <= 4) return 'Spécialité';
  if (niveauInt === 5) return 'Option';
  return '';
};

export const getSpecialitesIngenieur = (cycle) => {
  if (!cycle || !STRUCTURE_FORMATION.CYCLE_INGENIEUR.cycles[cycle]) return [];
  return STRUCTURE_FORMATION.CYCLE_INGENIEUR.cycles[cycle].specialites || [];
};

export const getOptionsIngenieur = (cycle, specialite) => {
  if (!cycle || !specialite || !STRUCTURE_FORMATION.CYCLE_INGENIEUR.cycles[cycle]) return [];
  const cycleData = STRUCTURE_FORMATION.CYCLE_INGENIEUR.cycles[cycle];
  return cycleData.options && cycleData.options[specialite]
    ? cycleData.options[specialite]
    : [];
};

export const isTypeFormationIngenieur = (filiere) => {
  return filiere === 'CYCLE_INGENIEUR';
};

export const getCoursFiltre = (listeCours, form) => {
  if (!form.filiere || !listeCours.length) return [];
  const candidats = buildCoursCandidates(form);
  if (!candidats.length) return [];

  return listeCours.filter(cours => {
    const nomCours = normalize(cours.nom || cours);
    return candidats.some(candidat => {
      const nc = normalize(candidat);
      return nomCours.includes(nc) || nc.includes(nomCours);
    });
  });
};

// ==================== FORMATION CHANGE HANDLER ====================
export const handleFormationChange = (formSetter, currentForm) => (field, value) => {
  const newForm = { ...currentForm };

  if (field === 'niveauFormation') {
    newForm.niveauFormation = value;
    newForm.filiere = '';
    newForm.niveau = '';
    newForm.cycle = '';
    newForm.specialite = '';
    newForm.option = '';
    newForm.specialiteIngenieur = '';
    newForm.optionIngenieur = '';
    newForm.specialiteLicencePro = '';
    newForm.optionLicencePro = '';
    newForm.specialiteMasterPro = '';
    newForm.optionMasterPro = '';
    newForm.cours = [];
  }

  if (field === 'filiere') {
    newForm.filiere = value;
    newForm.cours = [];
    newForm.cycle = '';
    newForm.specialiteIngenieur = '';
    newForm.optionIngenieur = '';
    newForm.specialiteLicencePro = '';
    newForm.optionLicencePro = '';
    newForm.specialiteMasterPro = '';
    newForm.optionMasterPro = '';
    newForm.specialite = '';
    newForm.option = '';

    const formationData = STRUCTURE_FORMATION[value];
    if (formationData && !formationData.niveauxManuels) {
      newForm.niveau = String(formationData.niveauFixe);
    } else {
      newForm.niveau = '';
    }
  } else if (field === 'niveau') {
    newForm.niveau = String(value);
    newForm.cours = [];

    if (newForm.filiere === 'CYCLE_INGENIEUR') {
      const nouveauCycle = getCycleParNiveau(String(value));
      newForm.cycle = nouveauCycle;

      if (nouveauCycle === 'Classes Préparatoires Intégrées') {
        newForm.specialiteIngenieur = '';
        newForm.optionIngenieur = '';
      } else if (nouveauCycle === 'Cycle Ingénieur') {
        const specialitesDisponibles = getSpecialitesIngenieur(nouveauCycle);
        if (!specialitesDisponibles.includes(newForm.specialiteIngenieur)) {
          newForm.specialiteIngenieur = '';
        }
        if (parseInt(value) !== 5) {
          newForm.optionIngenieur = '';
        }
      }
    }

    if ((newForm.filiere === 'MASI' || newForm.filiere === 'IRM')) {
      const niveauInt = parseInt(value);
      if (niveauInt <= 2) {
        newForm.specialite = '';
        newForm.option = '';
      } else if (niveauInt <= 4) {
        newForm.option = '';
        const specialitesDisponibles = getSpecialitesDisponibles(newForm.filiere, String(value));
        if (!specialitesDisponibles.includes(newForm.specialite)) {
          newForm.specialite = '';
        }
      }
    }
  } else if (field === 'specialiteIngenieur') {
    newForm.specialiteIngenieur = value;
    newForm.optionIngenieur = '';
  } else if (field === 'optionIngenieur') {
    newForm.optionIngenieur = value;
  } else if (field === 'specialiteLicencePro') {
    newForm.specialiteLicencePro = value;
    newForm.optionLicencePro = '';
  } else if (field === 'optionLicencePro') {
    newForm.optionLicencePro = value;
  } else if (field === 'specialiteMasterPro') {
    newForm.specialiteMasterPro = value;
    newForm.optionMasterPro = '';
  } else if (field === 'optionMasterPro') {
    newForm.optionMasterPro = value;
  } else if (field === 'specialite') {
    newForm.specialite = value;
    const optionsDisponibles = getOptionsDisponibles(newForm.filiere, newForm.niveau, value);
    if (!optionsDisponibles.includes(newForm.option)) {
      newForm.option = '';
    }
  } else if (field === 'option') {
    newForm.option = value;
  } else if (field === 'doubleCompetenceIT') {
    newForm.doubleCompetenceIT = Boolean(value);
    if (!value) {
      newForm.niveauFormation2 = '';
      newForm.filiere2 = '';
      newForm.specialite2 = '';
      newForm.option2 = '';
    }
  } else if (field === 'niveauFormation2') {
    newForm.niveauFormation2 = value;
    newForm.filiere2 = '';
    newForm.specialite2 = '';
    newForm.option2 = '';
  } else if (field === 'filiere2') {
    newForm.filiere2 = value;
    newForm.specialite2 = '';
    newForm.option2 = '';
  } else if (field === 'specialite2') {
    newForm.specialite2 = value;
    newForm.option2 = '';
  } else if (field === 'option2') {
    newForm.option2 = value;
  } else {
    newForm[field] = value;
  }

  formSetter(newForm);
};

// ==================== VALIDATION ====================
export const genererAnneeScolaireActuelle = () => {
  const anneeActuelle = new Date().getFullYear();
  const moisActuel = new Date().getMonth() + 1;
  const anneeDebut = moisActuel >= 5 ? anneeActuelle : anneeActuelle - 1;
  const anneeFin = anneeDebut + 1;
  return `${anneeDebut}/${anneeFin}`;
};

export const validerAnneeScolaire = (anneeScolaire) => {
  if (!anneeScolaire) return "L'année scolaire est obligatoire";

  const regex = /^\d{4}\/\d{4}$/;
  if (!regex.test(anneeScolaire)) {
    return "L'année scolaire doit être au format YYYY/YYYY (ex: 2025/2026)";
  }

  const [annee1, annee2] = anneeScolaire.split('/').map(Number);
  if (annee2 !== annee1 + 1) {
    return "La deuxième année doit être consécutive à la première (ex: 2025/2026)";
  }

  return null;
};

export const validerFormationComplete = (form) => {
  const erreurs = [];

  if (!form.niveauFormation) {
    erreurs.push('Le type de formation (FI/TA/Executive) est obligatoire');
  } else {
    const allowed = new Set(getFilieresParMode(form.niveauFormation));
    if (form.filiere && !allowed.has(form.filiere)) {
      erreurs.push(`La filière "${form.filiere}" n'est pas autorisée pour ${form.niveauFormation}`);
    }
  }

  if (!form.filiere) {
    erreurs.push('La filière est obligatoire');
    return erreurs;
  }

  if (form.filiere === 'LICENCE_PRO') {
    if (!form.specialiteLicencePro) {
      erreurs.push('Une spécialité Licence Pro est obligatoire');
    }
    const formationData = STRUCTURE_FORMATION.LICENCE_PRO;
    const specNorm = normalize(form.specialiteLicencePro);
    if (form.specialiteLicencePro && !formationData.specialites.some(s => normalize(s) === specNorm)) {
      erreurs.push('Cette spécialité n\'est pas disponible pour la Licence Pro');
    }
    const optionsDisponibles = formationData.options[form.specialiteLicencePro] || [];
    if (optionsDisponibles.length > 0 && !form.optionLicencePro) {
      erreurs.push('Une option Licence Pro est obligatoire pour cette spécialité');
    }
    const optNorm = normalize(form.optionLicencePro);
    if (form.optionLicencePro && optionsDisponibles.length > 0 && !optionsDisponibles.some(o => normalize(o) === optNorm)) {
      erreurs.push('Cette option n\'est pas disponible pour cette spécialité Licence Pro');
    }
    return erreurs;
  }

  if (form.filiere === 'MASTER_PRO') {
    // Nouvelle validation : le niveau Master (M1 ou M2) est obligatoire
    if (!form.niveau) {
      erreurs.push('Le niveau Master (M1 ou M2) est obligatoire');
    }
    if (!form.specialiteMasterPro) {
      erreurs.push('Une spécialité Master Pro est obligatoire');
    }
    const formationData = STRUCTURE_FORMATION.MASTER_PRO;
    const specNorm = normalize(form.specialiteMasterPro);
    if (form.specialiteMasterPro && !formationData.specialites.some(s => normalize(s) === specNorm)) {
      erreurs.push('Cette spécialité n\'est pas disponible pour le Master Pro');
    }
    const optionsDisponibles = formationData.options[form.specialiteMasterPro] || [];
    if (optionsDisponibles.length > 0 && !form.optionMasterPro) {
      erreurs.push('Une option Master Pro est obligatoire pour cette spécialité');
    }
    const optNorm = normalize(form.optionMasterPro);
    if (form.optionMasterPro && optionsDisponibles.length > 0 && !optionsDisponibles.some(o => normalize(o) === optNorm)) {
      erreurs.push('Cette option n\'est pas disponible pour cette spécialité Master Pro');
    }
    return erreurs;
  }

  if (!form.niveau) {
    erreurs.push('Le niveau est obligatoire');
    return erreurs;
  }

  const niveauInt = parseInt(form.niveau);

  if (isTypeFormationIngenieur(form.filiere)) {
    const cycleEffectif = form.cycle || getCycleParNiveau(form.niveau);
    if (!cycleEffectif) {
      erreurs.push('Le cycle est obligatoire pour la formation d\'ingénieur');
    }
    if (cycleEffectif === 'Cycle Ingénieur' && niveauInt >= 3 && !form.specialiteIngenieur) {
      erreurs.push('Une spécialité d\'ingénieur est obligatoire à partir de la 3ème année');
    }
    if (cycleEffectif === 'Cycle Ingénieur' && niveauInt === 5 && !form.optionIngenieur) {
      erreurs.push('Une option d\'ingénieur est obligatoire en 5ème année');
    }

    const cycleAttendu = getCycleParNiveau(form.niveau);
    if (cycleEffectif && cycleEffectif !== cycleAttendu) {
      erreurs.push(`Le cycle "${cycleEffectif}" ne correspond pas au niveau ${form.niveau}`);
    }

    if (cycleEffectif === 'Cycle Ingénieur' && form.specialiteIngenieur && form.optionIngenieur) {
      const optionsDisponibles = getOptionsIngenieur(cycleEffectif, form.specialiteIngenieur);
      const optNorm = normalize(form.optionIngenieur);
      if (optionsDisponibles.length > 0 && !optionsDisponibles.some(o => normalize(o) === optNorm)) {
        erreurs.push('Cette option n\'est pas disponible pour cette spécialité d\'ingénieur');
      }
    }
  } else {
    if (niveauInt >= 3 && !form.specialite) {
      erreurs.push('Une spécialité est obligatoire à partir de la 3ème année pour ' + form.filiere);
    }
    if (niveauInt === 5 && getOptionsDisponibles(form.filiere, form.niveau, form.specialite).length > 0 && !form.option) {
      erreurs.push('Une option est obligatoire en 5ème année pour ' + form.filiere);
    }

    if (form.filiere && form.niveau && form.specialite) {
      const specialitesDisponibles = getSpecialitesDisponibles(form.filiere, form.niveau);
      const specNorm = normalize(form.specialite);
      if (specialitesDisponibles.length > 0 && !specialitesDisponibles.some(s => normalize(s) === specNorm)) {
        erreurs.push('Cette spécialité n\'est pas disponible pour ce niveau et cette filière');
      }
    }

    if (form.filiere && form.niveau === '5' && form.specialite && form.option) {
      const optionsDisponibles = getOptionsDisponibles(form.filiere, form.niveau, form.specialite);
      const optNorm = normalize(form.option);
      if (optionsDisponibles.length > 0 && !optionsDisponibles.some(o => normalize(o) === optNorm)) {
        erreurs.push('Cette option n\'est pas disponible pour cette spécialité');
      }
    }
  }

  return erreurs;
};

// ==================== GENERATION ====================
export const genererCodeEtudiantMisAJour = (form) => {
  if (!form.filiere || !form.prenom || !form.nomDeFamille) {
    return '';
  }

  const annee = new Date().getFullYear();
  let filiereCode;

  if (isTypeFormationIngenieur(form.filiere)) {
    if (form.specialiteIngenieur) {
      const codeSpecialite = {
        'Génie Informatique': 'GI',
        'Génie Mécatronique': 'GM',
        'Génie Civil': 'GC'
      };
      filiereCode = codeSpecialite[form.specialiteIngenieur] || 'ING';
    } else {
      filiereCode = 'ING';
    }
  } else if (form.filiere === 'LICENCE_PRO') {
    filiereCode = 'LP';
  } else if (form.filiere === 'MASTER_PRO') {
    filiereCode = 'MP';
  } else if (form.filiere === 'GENIE_CIVIL') {
    filiereCode = 'GC';
  } else if (form.filiere === 'MECATRONIQUE') {
    filiereCode = 'GM';
  } else if (form.filiere === 'MASTER') {
    filiereCode = 'M';
  } else {
    filiereCode = form.filiere;
  }

  const niveau = form.niveau || '';
  const initiales = (form.prenom.charAt(0) + form.nomDeFamille.charAt(0)).toUpperCase();
  const timestamp = Date.now().toString().slice(-4);
  return `${filiereCode}${niveau}${annee}${initiales}${timestamp}`;
};

// ==================== HELPERS ====================
export const isManualFiliere = (filiere) => {
  return ['MASI', 'IRM', 'GENIE_CIVIL', 'MECATRONIQUE', 'MASTER'].includes(filiere);
};

export const formatDate = (isoDate) => {
  if (!isoDate) return 'N/A';
  const date = new Date(isoDate);
  const jour = String(date.getDate()).padStart(2, '0');
  const mois = String(date.getMonth() + 1).padStart(2, '0');
  const annee = date.getFullYear();
  return `${jour}-${mois}-${annee}`;
};

export const calculerAge = (dateNaissance) => {
  if (!dateNaissance) return 'N/A';
  const dob = new Date(dateNaissance);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age;
};

export const getNomComplet = (etudiant) => {
  return `${etudiant.prenom || ''} ${etudiant.nomDeFamille || ''}`.trim();
};

export const getNomCommercial = (commercialId, listeCommerciaux = []) => {
  if (!commercialId) return 'Aucun';
  if (typeof commercialId === 'object') {
    return commercialId.nomComplet || commercialId.nom || 'Aucun';
  }
  const commercial = Array.isArray(listeCommerciaux) ? listeCommerciaux.find(c => c._id === commercialId) : null;
  return commercial ? (commercial.nomComplet || commercial.nom) : 'Commercial supprimé';
};

export const getNomPartner = (nomPartner, listePartners) => {
  if (!nomPartner) return 'Aucun';
  if (typeof nomPartner === 'object' && nomPartner.nomPartner) {
    return nomPartner.nomPartner;
  }
  const partner = listePartners.find(p => p.id === nomPartner);
  return partner ? partner.nom : nomPartner;
};

// ==================== INITIAL FORM STATE ====================
export const getInitialFormState = () => ({
  prenom: '',
  nomDeFamille: '',
  genre: 'Homme',
  dateNaissance: '',
  telephone: '',
  email: '',
  motDePasse: '',
  cin: '',
  passeport: '',
  anneeScolaire: genererAnneeScolaireActuelle(),
  lieuNaissance: '',
  pays: '',
  ville: '',
  quartier: '',
  cours: [],
  niveau: '',
  niveauFormation: '',
  filiere: '',
  option: '',
  specialite: '',
  typeDiplome: '',
  diplomeAcces: '',
  specialiteDiplomeAcces: '',
  mention: '',
  lieuObtentionDiplome: '',
  serieBaccalaureat: '',
  anneeBaccalaureat: '',
  premiereAnneeInscription: '',
  sourceInscription: '',
  dateInscription: '',
  typePaiement: '',
  modePaiement: 'mensuel',
  prixTotal: '',
  pourcentageBourse: '',
  situation: '',
  codeEtudiant: '',
  dateEtReglement: '',
  numRecu: '',
  actif: true,
  nouvelleInscription: true,
  paye: false,
  handicape: false,
  resident: false,
  fonctionnaire: false,
  mobilite: false,
  commercial: '',
  cycle: '',
  specialiteIngenieur: '',
  optionIngenieur: '',
  specialiteLicencePro: '',
  optionLicencePro: '',
  specialiteMasterPro: '',
  optionMasterPro: '',
  doubleCompetenceIT: false,
  niveauFormation2: '',
  filiere2: '',
  specialite2: '',
  option2: '',
  telephoneResponsable: '',
  codeBaccalaureat: '',
  codeMassar: '',
  isPartner: false,
  nomPartner: '',
  prixTotalPartner: '',
  fraisInscription: 3000,
  fraisScolariteBase: 35000,
  typeRemise: 'none',
  remiseMontant: 0,
  commentaireCin: '',
  commentaireBacCommentaire: '',
  commentaireReleveNoteBac: '',
  commentaireDiplomeCommentaire: '',
  commentaireAttestationReussiteCommentaire: '',
  commentaireReleveNotesFormationCommentaire: '',
  commentairePasseport: '',
  commentaireBacOuAttestationBacCommentaire: '',
  commentaireAuthentificationBac: '',
  commentaireAuthenticationDiplome: '',
  commentaireEngagementCommentaire: ''
});

// ==================== CONFIGURATION TARIFS & REMISES 2026-2027 ====================

export const TARIFFS_2026_2027 = {
  INSCRIPTION_FEE: 3000,
  LICENCE_SCOLARITE: 35000,
  MASTER_SCOLARITE: 39000
};

export const REMISES_LIST = [
  { id: 'none', label: 'Aucune remise', type: 'fixed', value: 0 },
  { id: 'bourse_tb', label: "Bourse d'excellence - Mention Très Bien (15%)", type: 'percent', value: 15 },
  { id: 'bourse_b', label: "Bourse d'excellence - Mention Bien (10%)", type: 'percent', value: 10 },
  { id: 'parrainage_fam', label: 'Parrainage Familial (15%)', type: 'percent', value: 15 },
  { id: 'parrainage_etud', label: 'Parrainage Étudiant-Étudiant (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'orientateur', label: 'Orientateur (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'prof_ext', label: 'Prof externe (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'prof_int', label: 'Prof interne (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'staff_sup2i_enfants', label: 'Famille staff SUP2I (Gratuit pour enfants - 100%)', type: 'percent', value: 100 },
  { id: 'parrainage_staff', label: 'Parrainage staff SUP2I (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'partenariat_ofppt', label: 'Partenariat OFPPT (5000 DH)', type: 'fixed', value: 5000 },
  { id: 'apporteur_5', label: "Apporteur d'affaires (5%)", type: 'percent', value: 5 },
  { id: 'apporteur_10', label: "Apporteur d'affaires (10%)", type: 'percent', value: 10 },
  { id: 'ministere', label: 'Ministère (5%)', type: 'percent', value: 5 },
  { id: 'totalite', label: 'Paiement en totalité (5%)', type: 'percent', value: 5 },
  { id: 'salon_jpo_1000', label: 'Remise Salon & JPO (1000 DH)', type: 'fixed', value: 1000 },
  { id: 'salon_jpo_1500', label: 'Remise Salon & JPO (1500 DH)', type: 'fixed', value: 1500 },
  { id: 'salon_jpo_2000', label: 'Remise Salon & JPO (2000 DH)', type: 'fixed', value: 2000 },
  { id: 'jpo_exon', label: "Remise JPO (Exonération frais d'inscription)", type: 'exon_inscription', value: 0 },
  { id: 'custom', label: 'Remise Exceptionnelle (Saisie manuelle)', type: 'custom', value: 0 }
];

export const isMasterProgram = (filiere, niveau) => {
  const levelNum = parseInt(niveau, 10);
  if (filiere === 'MASTER' || filiere === 'MASTER_PRO') {
    return true;
  }
  if ((filiere === 'MASI' || filiere === 'IRM') && (levelNum === 4 || levelNum === 5)) {
    return true;
  }
  return false;
};

export const calculateStudentPrice = (filiere, niveau, typeRemise, customRemiseValue = 0) => {
  let scolariteBase;
  let inscriptionFee;

  if (filiere === 'LICENCE_PRO') {
    scolariteBase = 25000;
    inscriptionFee = 0;
  } else if (filiere === 'MASTER_PRO') {
    scolariteBase = 30000;
    inscriptionFee = 0;
  } else {
    const isMaster = isMasterProgram(filiere, niveau);
    scolariteBase = isMaster ? TARIFFS_2026_2027.MASTER_SCOLARITE : TARIFFS_2026_2027.LICENCE_SCOLARITE;
    inscriptionFee = TARIFFS_2026_2027.INSCRIPTION_FEE;
  }

  const remise = REMISES_LIST.find(r => r.id === typeRemise) || { type: 'fixed', value: 0 };

  let remiseMontant = 0;
  if (remise.type === 'percent') {
    remiseMontant = (remise.value / 100) * scolariteBase;
  } else if (remise.type === 'fixed') {
    remiseMontant = remise.value;
  } else if (remise.type === 'exon_inscription') {
    inscriptionFee = 0;
    remiseMontant = 0;
  } else if (remise.type === 'custom') {
    remiseMontant = parseFloat(customRemiseValue) || 0;
  }

  // Si Famille staff SUP2I (Gratuit pour enfants), tout est gratuit (0 DH en tout)
  if (typeRemise === 'staff_sup2i_enfants') {
    inscriptionFee = 0;
    remiseMontant = scolariteBase;
  }

  const prixTotal = inscriptionFee + Math.max(0, scolariteBase - remiseMontant);
  const pourcentageBourse = remise.type === 'percent' ? remise.value : Math.round((remiseMontant / scolariteBase) * 100);

  return {
    fraisInscription: inscriptionFee,
    fraisScolariteBase: scolariteBase,
    remiseMontant,
    prixTotal,
    pourcentageBourse: Math.min(100, Math.max(0, pourcentageBourse))
  };
};